import React from 'react';
import {
  EntityImagesGallery,
  createNewImageItem
} from '../../../../../components/EntityImagesGallery';
import {
  ToggleCopy,
  ToggleDescription,
  ToggleTitle
} from './addAmenityWizardStylesV2';

function AddAmenityImagesStepV2({
  t,
  amenityImages,
  setAmenityImages,
  building,
  mapNewImage
}) {
  const td = (key, fallback) => t(key, { defaultValue: fallback });

  return (
    <>
      <ToggleCopy>
        <ToggleTitle>
          {t('add_amenity_add_images_toggle_title', {
            defaultValue: 'Add images to amenity'
          })}
        </ToggleTitle>
        <ToggleDescription>
          {td(
            'add_amenity_add_images_toggle_desc',
            'Add up to 10 images per amenity.'
          )}
        </ToggleDescription>
      </ToggleCopy>

      <div style={{ marginTop: 16 }}>
        <EntityImagesGallery
          t={t}
          images={amenityImages}
          setImages={setAmenityImages}
          building={building}
          mapNewImage={
            mapNewImage ||
            ((file) => createNewImageItem(file))
          }
          dropzoneTitle={t('add_amenity_images_dropzone_title', {
            defaultValue: 'Drag and drop your amenity images'
          })}
          dropHereText={t('add_amenity_images_drop_here', {
            defaultValue: 'Drop images here…'
          })}
          constraintsText={t('add_amenity_images_dropzone_subline', {
            defaultValue: '5MB max file size. JPG and PNG supported.'
          })}
          maxReachedText={t('add_amenity_images_max_reached', {
            defaultValue: 'Max ten images reached.'
          })}
          coverLabel={t('Cover')}
        />
      </div>
    </>
  );
}

export default AddAmenityImagesStepV2;
